<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('certificateOperationPrint.pageTitle') }}
      </h1>
      <ts-breadcrumb :items="[
        { text: $t('toHomePage'), href: '/' },
        { text: $t('certificateOperationPrint.pageTitle'), active: true }
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper class="ts-flex ts-items-center ts-justify-between">
        <div>
          <ts-button color="info" outline @click="addNew">
            {{ $t('add_new') }}
          </ts-button>

          <a-range-picker class="ml-3" format="DD-MM-YYYY" :defaultValue="rangeDate" :defaultPickerValue="rangeDate"
            @change="dateRangeChhange">
            <template slot="renderExtraFooter"></template>
          </a-range-picker>
        </div>
        <div class="ts-flex ts-justify-end ts-space-x-2">
          <label class="mt-2 mr-2">{{
            $t('certificateOperationPrint.certificateType')
          }}</label>
          <select class="form-control" style="width: 200px" v-model="certificate_type_id">
            <option :value="null">
              {{ $t('all') }}
            </option>
            <option v-for="(s, index) in certificate_types" :key="index" :value="s.certificate_type_id">
              {{ s.certificate_type }}
            </option>
          </select>
          <a-input v-model="search" v-tooltip="$t('search')" :placeholder="$t('search')" style="width: 250px"
            class="inline-block" />
          <ts-button outline v-tooltip="$t('filter')" @click.prevent="visible = true">
            <i class="fa fa-filter"></i>
          </ts-button>
        </div>
      </ts-card-wrapper>
    <div class="ts-overflow-auto">
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          
          <td class="ts-whitespace-nowrap">
            <template v-if="record.certificate_type_id == 1">
              {{ record.details && record.details[0] && record.details[0].student && record.details[0].student.branch ? record.details[0].student.branch.branch_name_en : '' }}
            </template>
            <template v-else-if="[2, 5].includes(record.certificate_type_id)">
              {{ record.student && record.student.branch ? record.student.branch.branch_name_en : '' }}
            </template>
            <template v-else>
              {{ record.branch ? record.branch.branch_name_en : '' }}
            </template>
          </td>

          <td class="ts-whitespace-nowrap ts-text-center">
            {{ record.certificate_number }}
          </td>

          <td class="ts-whitespace-nowrap">
            {{ record.certificate_types ? record.certificate_types.certificate_type : '' }}
          </td>

          <td class="ts-whitespace-nowrap">
            <template v-if="record.certificate_type_id == 1">
              <span v-for="(detail, i) in record.details" :key="i">
                {{ detail.student ? detail.student.full_name_en : '' }} <br />
              </span>
            </template>
            <template v-else-if="record.certificate_type_id == 7">
              {{ record.staff ? record.staff.name_en : '' }}
            </template>
            <template v-else>
              {{ record.student ? record.student.full_name_en : '' }}
            </template>
          </td>

          <td class="ts-whitespace-nowrap ts-text-center">
            <template v-if="record.certificate_type_id == 1">
              <span v-for="(detail, i) in record.details" :key="i">
                {{ detail.student ? detail.student.gender : '' }} <br />
              </span>
            </template>
            <template v-else-if="record.certificate_type_id == 7">
              {{ record.staff ? (record.staff.gender == 1 ? 'Male' : 'Female') : '' }}
            </template>
            <template v-else>
              {{ record.student ? record.student.gender : '' }}
            </template>
          </td>

         <td class="ts-whitespace-nowrap">
          <template v-if="record.certificate_type_id == 1">
            <span v-for="(detail, i) in record.details" :key="i">
              {{ detail.student ? detail.student.phone : '' }} <br />
            </span>
          </template>

          <template v-else-if="record.certificate_type_id == 7">
            {{ record.staff ? record.staff.phone_number_1 : '' }}
          </template>

          <template v-else>
            {{ record.student ? record.student.phone : '' }}
          </template>
        </td>

          <td class="ts-whitespace-nowrap">
            {{ record.component_skill ? record.component_skill.comp_item_name : '' }}
          </td>

          <td class="ts-text-center ts-whitespace-nowrap">
            {{ record.academic_year ? record.academic_year.ac_year : '' }}
          </td>

          <td class="ts-text-left ts-whitespace-nowrap">
            {{ 
              record.certificate_type_id == 7 
                ? '' 
                : (record.sub_program ? record.sub_program.acps_name_foreign : '') 
            }}
          </td>

          <td class="ts-whitespace-nowrap">
            {{ record.classes ? record.classes.class_name : '' }}
          </td>

          <td class="ts-text-left w-whitespace-nowrap">
            {{ record.printed_by && record.printed_by.employee ? record.printed_by.employee.name_en : '' }}
          </td>

          <td class="w-whitespace-nowrap">
            {{ record.printed_at }}
          </td>

          <td class="text-center ts-whitespace-nowrap">
            <a href="#" v-tooltip="$t('pdf')" class="text-danger" @click.prevent="print(record)">
              <i class="fas fa-file-pdf"></i>
            </a>
          </td>
        </template>
      </ts-table>
    </div>

      <div class="d-flex justify-content-between align-items-center p-15">
        <ts-total-list v-model="pagination" />
        <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
      </div>
    </ts-card>
    <a-drawer :title="$t('filter')" :closable="false" :visible="visible" :zIndex="1020" @close="() => (visible = false)"
      width="300px">
      <div class="mb-3">
        <label class="form-col-label control-label">{{
          $t('certificateOperationPrint.branch')
        }}</label>
        <ts-branch-filter @filter="value => (branch_id = value)" />
      </div>
    </a-drawer>
    <a-modal v-if="showForm" v-model="showForm" :title="$t('certificateOperationPrint.pageTitle')" centered
      :maskClosable="false" @cancel="fetchData" :zIndex="1020" :footer="null" width="1080px">
      <from-action @cancel="() => (showForm = false)" @fetchData="fetchData" />
    </a-modal>
    <a-modal :title="$t('pdf')" width="70%" v-model="show_pdf" :footer="null">
      <ts-preview-pdf v-model="waiting" :src="src" />
    </a-modal>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState, mapActions } from 'vuex'
import FromAction from './form.vue'
import { Errors } from 'form-backend-validation'
import moment from 'moment'

export default {
  name: 'certificateOperationPrintIndex',
  components: {
    FromAction
  },
  data() {
    return {
      errors: new Errors(),
      loading: false,
      waiting: false,
      src: '',
      showForm: false,
      show_pdf: false,
      visible: false,
      ac_year: null,
      branch_id: [],
      certificate_types: [],
      rangeDate: [moment(), moment()]
    }
  },
  computed: {
    ...mapState('certificateOperationPrint', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.certificateOperationPrint.search
      },
      set(newValue) {
        this.$store.commit('certificateOperationPrint/SET_SEARCH', newValue)
        this.$store.commit('certificateOperationPrint/RESET_CURRENT_PAGE')
      }
    },
    certificate_type_id: {
      get() {
        return this.$store.state.certificateOperationPrint.certificate_type_id
      },
      set(newValue) {
        this.$store.commit(
          'certificateOperationPrint/SET_CERTIFICATE_TYPE_ID',
          newValue
        )
      }
    },
    date_from: {
      get() {
        return this.$store.state.certificateOperationPrint.date_from
      }
    },
    date_to: {
      get() {
        return this.$store.state.certificateOperationPrint.date_to
      }
    },
    columns() {
      return [
        {
          name: this.$t('certificateOperationPrint.branch'),
          style: 'white-space: nowrap;'
        },
        {
          name: this.$t('certificateOperationPrint.certificateNumber'),
          style: 'text-align:center;white-space: nowrap;'
        },
        {
          name: this.$t('certificateOperationPrint.certificateType'),
          style: 'white-space: nowrap;'
        },
        {
          name: this.certificate_type_id == 7 
                ? this.$t('certificateOperationPrint.employeeName') 
                : (this.certificate_type_id == null 
                    ? this.$t('name') // Or 'Full Name'
                    : this.$t('certificateOperationPrint.studentName')),
          style: 'white-space: nowrap;'
        },
        {
          name: this.$t('certificateOperationPrint.sex'),
          style: 'text-align:center;white-space: nowrap;'
        },
        {
          name: this.$t('certificateOperationPrint.phone'),
          style: 'white-space: nowrap;'
        },
        {
          name: this.$t('certificateOperationPrint.skill'),
          style: 'white-space: nowrap;'
        },
        {
          name: this.$t('certificateOperationPrint.academicYear'),
          style: 'text-align:center;white-space: nowrap;'
        },
        {
          name: this.$t('certificateOperationPrint.subProgram'),
          style: 'white-space: nowrap;'
        },
        {
          name: this.$t('certificateOperationPrint.className'),
          style: 'white-space: nowrap;'
        },
        {
          name: this.$t('certificateOperationPrint.printedBy'),
          style: 'white-space: nowrap;'
        },
        {
          name: this.$t('certificateOperationPrint.printedDate'),
          style: 'white-space: nowrap;'
        },
        {
          name: this.$t('actions'),
          style: 'text-align:center; width: 5%;'
        }
      ]
    }
  },
  methods: {
    ...mapActions('certificateOperationPrint', ['getCertificateType']),
    async fetchData(attributes) {
      this.loading = true
      await this.getCertificateType().then(response => {
        this.certificate_types = response.data
      })
      this.$store
        .dispatch('certificateOperationPrint/fetch',
          Object.assign(
            {
              page: this.pagination.currentPage
            },
            attributes
          )
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew() {
      this.showForm = true
    },
    dateRangeChhange(dateRange) {
      this.$store.commit(
        'certificateOperationPrint/SET_DATE_FROM',
        dateRange[0].format('DD-MM-YYYY')
      )
      this.$store.commit(
        'certificateOperationPrint/SET_DATE_TO',
        dateRange[1].format('DD-MM-YYYY')
      )
    },
    print(record) {
      this.show_pdf = true
      this.waiting = true
      this.src = ''
      this.$store
        .dispatch('certificateOperationPrint/printPdf', {
          id: [record.id],
          cycle_value: record.cycle_value,
          scoring_cycle_id : record.scoring_cycle_id,
          class_id: record.class_id,
          sc_item_subject_comp_id: record.sc_item_subject_comp_id,
          certificate_type_id: record.certificate_type_id
        })
        .then(response => {
          this.src = response.url
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    }
  },
  watch: {
    search: debounce(function () {
      this.fetchData()
    }, 500),
    branch_id: debounce(function (value) {
      this.fetchData({ branch_id: value })
    }, 500),
    certificate_type_id: debounce(function (certificate_type_id) {
      this.fetchData({
        certificate_type_id,
        search: this.search,
        branch_id: this.branch_id
      })
    }, 500),
    date_from: debounce(function () {
      this.fetchData()
    }, 500),
    date_to: debounce(function () {
      this.fetchData()
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('certificateOperationPrint/RESET_STATE')
    next()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>
